// extracted by mini-css-extract-plugin
module.exports = {"chatInput":"ChatInput_chatInput__SZItX","input":"ChatInput_input__9Qp4U"};